<template>
  <v-row>
    <v-dialog v-model="dialog.active" persistent width="600">
      <v-card>
        <v-card-title>
          {{
            $t("components.dialogs.importBoatDialog.importBoatFromMIS")
          }}</v-card-title
        >
        <v-card-text>
          <device-selector :device-serial.sync="deviceSerial"></device-selector>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onCancel()"
            data-cy="importServiceProtocolDialogCancelBtn"
            >{{ $t("components.dialogs.importBoatDialog.cancel") }}</v-btn
          >
          <v-btn color="primary" text @click="onImport()">{{
            $t("components.dialogs.importBoatDialog.import")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import DeviceSelector from "@/components/selectors/DeviceSelector";
export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  components: {
    DeviceSelector,
  },
  data: () => ({
    deviceSerial: {},
  }),
  created() {},
  methods: {
    onImport() {
      this.$emit("import", this.deviceSerial);
    },
    onCancel() {
      this.$emit("import", false);
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
